class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;

    this.setupEventListeners();
    this.page = 1;
    this.pages = 1;
    this.isFetching = false;
    this.eventHandler = null;
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm, true);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm, true);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  getSearchResults(searchTerm, first) {
    if(first){
      this.page = 1;
      if(this.eventHandler){
        this.predictiveSearchResults.removeEventListener('scroll', this.eventHandler);
        this.eventHandler = null;
      }
      // this.predictiveSearchResults.innerHTML = 'loading';
      this.setLiveRegionLoadingState();
    }
    // console.log('first',first);
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    // if (this.cachedResults[queryKey]) {
    //   this.renderSearchResults(this.cachedResults[queryKey]);
    //   return;
    // }
    this.isFetching = true;
    // let localName = Shopify.routes.root === '/' ? '' : Shopify.routes.root
    fetch(`${Shopify.routes.root}search?sections=main-search&type=product&q=${encodeURIComponent(searchTerm)}'&page=${this.page}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.json();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text['main-search'], 'text/html').querySelector('#ProductGridContainer').innerHTML;
        if(first){
          const numberOfPages = new DOMParser().parseFromString(text['main-search'], 'text/html').querySelector("[data-search-pages]").getAttribute('data-search-pages');
          this.pages = +numberOfPages;
          // console.log('page' , this.page);
          // console.log('pages' , this.pages);
        }
        this.cachedResults[queryKey] = resultsMarkup;
        // console.log(resultsMarkup);
        this.renderSearchResults(resultsMarkup,first);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup, first) {
    if(first){
      this.predictiveSearchResults.innerHTML = resultsMarkup;
    }else{
      const productGridContainer = new DOMParser().parseFromString(resultsMarkup, 'text/html').querySelector('#Huratips-Loop');
      Array.from(productGridContainer.children).forEach((item) => {
        this.predictiveSearchResults.querySelector('#Huratips-Loop').append(item);
      })
    }
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    this.isFetching = false;

    if(first){
      this.predictiveSearchResults.querySelector('#Huratips-Loop').classList.add('loadingResults');
      const productGridContainer = this.predictiveSearchResults.querySelector('#Huratips-Loop');
      this.eventHandler = (e) => {
        // console.log('event listener working!');
        // console.log('current page' , this.page);
        // console.log('pages' , this.pages);
        if(productGridContainer.getBoundingClientRect().bottom - 100 <= this.predictiveSearchResults.querySelector('.template-search__results').getBoundingClientRect().bottom && this.pages > this.page && this.isFetching == false){
          // console.log('if statment');
          this.page++;
          console.log(this.page)
          this.getSearchResults(this.getQuery())
        }
      }
      this.predictiveSearchResults.querySelector('.template-search__results').addEventListener('scroll', this.eventHandler);
    }
    if(this.page == this.pages){
      this.predictiveSearchResults.querySelector('#Huratips-Loop').classList.remove('loadingResults');
    }
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText();
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
    document.body.classList.add('overflow-hidden');
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');

    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('predictive-search', PredictiveSearch);

document.querySelectorAll('form.search').forEach((form) => {
  form.addEventListener('submit', (e) => {
    e.preventDefault();
  })
});
